export default (that) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq',
  },
  {
    field: 'col-opt',
    title: that.$l('INDEX.table_label_operation') || '操作',
    headerAlign: 'center',
    align: 'center',
    fixed: 'right',
    width: 90,
    slots: { default: 'opt' },
  },
  {
    title: that.$l('table_label_payBillNo') || '申请单号',
    field: 'payBillNo',
    minWidth: 150,
    align: 'center',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_payBillType') || '单据类型',
    field: 'payBillType',
    minWidth: 150,
    align: 'center',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_receiveStatus') || '发票状态',
    field: 'receiveStatus',
    width: 100,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
    slots: { default: 'receiveStatus' },
  },
  {
    title: that.$l('table_label_salesPersonName') || '申请人',
    field: 'salesPersonName',
    width: 100,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_billStatus') || '申请单状态',
    field: 'billStatus',
    width: 100,
    align: 'center',
    showHeaderOverflow: true,
    slots: { default: 'billStatus' },
  },
  {
    title: that.$l('table_label_requestDate') || '申请日期',
    field: 'requestDate',
    width: 100,
    align: 'center',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_expensePayerName') || '申请公司',
    field: 'expensePayerName',
    minWidth: 200,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_currencyAmount') || '申请金额',
    field: 'currencyAmount',
    minWidth: 100,
    align: 'left',
    showHeaderOverflow: true,
    showOverflow: true,
    slots: { default: 'currencyAmount' },
  },
  {
    title: that.$l('table_label_receiveByName') || '发票确认人',
    field: 'receiveByName',
    width: 150,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_receiveByDate') || '发票确认时间',
    field: 'receiveTime',
    width: 180,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
    showOverflow: true,
  },
]
